const baseUrl = process.env.REACT_APP_URL;

const defaultOptions = () => ({
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
});

const options = options => ({ ...defaultOptions(), ...options });

const json = res => res.json();

const getUrl = url => `${baseUrl}form/api/${url}`;

const get = url => fetch(getUrl(url), options()).then(json);

const post = (url, body) =>
  fetch(
    getUrl(url),
    options({ method: 'POST', body: JSON.stringify(body) })
  ).then(json);

const api = {
  registerEmail: async (email, token) => {
    const success = await post('email', { email, token });
    return success;
  },
  getAttendeeFromConfirmEmailCode: async confirmEmailCode => {
    const attendee = await post('confirmEmailCode', { confirmEmailCode });
    return attendee;
  },
  getCourses: async () => {
    const courses = await get('courses');
    return courses;
  },
  registerCourse: async ({ id, name, courseId }) =>
    post('course', { id, name, courseId }),
};

export default api;
